import React from 'react';
import { Link } from 'react-router-dom';
import authService from 'src/services/api/auth';
import queryString from 'query-string';
import { changeDocTitle, chPerm } from 'src/components/helpers';
import MultiUserModal from './components/multiuserModal';
import { HomeComponent } from 'src/assets/styles/components/Home';

const RegisterModule = (props) => {
  const currentUser = authService.getCurrentUser();
  const parsedQueryString = queryString.parse(props.location.search);
  const guestIdQuery = parsedQueryString.id ? `?id=${parsedQueryString.id}` : '';

  React.useEffect(() => {
    changeDocTitle('Administrar');
  }, []);

  const modules = [
    {
      key: 'registration',
      to: '/registration',
      title: 'Registro nuevo',
      description: 'Crea personas nuevas en la plataforma.',
      visible: chPerm(['events']),
      group: 'Operación',
    },
    {
      key: 'crecer-checkin',
      to: `/checkin/crecer${guestIdQuery}`,
      title: 'Ingreso Crecer',
      description: 'Control de asistencia a clases y encuentros de Crecer.',
      visible: chPerm(['crecer']),
      group: 'Operación',
    },
    {
      key: 'service-checkin',
      to: `/checkin/servicio?eventSN=Auditorio_Principal${
        parsedQueryString.id ? `&id=${parsedQueryString.id}` : ''
      }`,
      title: 'Ingreso Servicio',
      description: 'Check-in de asistentes al servicio en auditorio.',
      visible: chPerm(['events']),
      group: 'Operación',
    },
    {
      key: 'print-queue',
      to: '/checkin/print-queue',
      title: 'Cola de impresión',
      description: 'Gestiona la impresión de escarapelas y tickets.',
      visible: chPerm(['events']),
      group: 'Operación',
    },
    {
      key: 'generaciones',
      to: '/servicio/generaciones',
      title: 'Ingreso Generaciones',
      description: 'Ingreso y acompañamiento de Generaciones.',
      visible: chPerm(['generaciones']),
      group: 'Operación',
    },
    {
      key: 'seminary-groups',
      to: '/grupos/lider?kindgroup=Grupo_Seminario',
      title: 'Asistencia grupos seminario',
      description: 'Toma asistencia de grupos vinculados a seminario.',
      visible: chPerm(['seminary'], true),
      group: 'Grupos',
    },
    {
      key: 'volunteers',
      to: '/voluntarios-servicio',
      title: 'Ingreso voluntarios',
      description: 'Check-in de voluntarios confirmados para el servicio.',
      visible: chPerm(['salaExp', 'experienceCoord', 'volunteers']),
      group: 'Experiencia',
    },
    {
      key: 'new-members',
      to: '/admin/new-members',
      title: 'Conexión',
      description: 'Consulta y da seguimiento a los nuevos miembros.',
      visible: chPerm(['newMembers'], true),
      group: 'Experiencia',
    },
    {
      key: 'intranet',
      to: '/intranet/institutional',
      title: 'Intranet Colaboradores',
      description: 'Accede a recursos e información institucional.',
      visible: chPerm(['staff'], true),
      group: 'Colaboradores',
    },
  ].filter((module) => module.visible);

  const groupedModules = modules.reduce((groups, module) => {
    if (!groups[module.group]) groups[module.group] = [];
    groups[module.group].push(module);
    return groups;
  }, {});

  return (
    <>
      {false && currentUser.multiuser && <MultiUserModal />}
      <HomeComponent>
        <div className="StaffHome">
          <header className="StaffHome__header">
            <p className="StaffHome__brand">Comunidad MDE</p>
            <h1 className="title">Panel de inicio</h1>
            <p className="StaffHome__intro">
              ¡Hola <strong>{currentUser.name}</strong>! Estas son algunas de las acciones
              transaccionales rápidas.
            </p>
          </header>

          {modules.length === 0 ? (
            <p className="StaffHome__empty">
              No tienes módulos asignados por ahora. Si crees que es un error, contacta a un
              administrador.
            </p>
          ) : (
            <div className="StaffHome__groups">
              {Object.entries(groupedModules).map(([group, groupModules]) => (
                <section key={group} className="StaffHome__group" aria-label={group}>
                  <h2 className="StaffHome__group-title">{group}</h2>
                  <nav className="StaffHome__grid">
                    {groupModules.map((module) => (
                      <Link key={module.key} to={module.to} className="StaffHome__tile">
                        <span className="StaffHome__tile-copy">
                          <span className="StaffHome__tile-title">{module.title}</span>
                          <span className="StaffHome__tile-description">{module.description}</span>
                        </span>
                        <span className="StaffHome__tile-arrow" aria-hidden="true">
                          →
                        </span>
                      </Link>
                    ))}
                  </nav>
                </section>
              ))}
            </div>
          )}

          {currentUser.profile === 1 && (
            <button
              type="button"
              className="StaffHome__admin"
              onClick={() => props.history.push('/?admin=open')}
            >
              Menú de administración
            </button>
          )}
        </div>
      </HomeComponent>
    </>
  );
};

export default RegisterModule;
